import PropTypes from 'prop-types';
import React from 'react';
import {Dimmer, Loader} from 'semantic-ui-react';

const Loading = ({isLoading, inverted, children}) => (
	<Dimmer inverted={inverted} active={isLoading}>
		<Loader>{children}</Loader>
	</Dimmer>
);

Loading.defaultProps = {
	inverted: true
};

Loading.propTypes = {
	isLoading: PropTypes.bool.isRequired,
	inverted: PropTypes.bool,
	children: PropTypes.oneOfType([
		PropTypes.element,
		PropTypes.string
	])
};

export default Loading;
